function canCancelAndRemind(status) {
  return status != "CANCELLED" && status != "COMPLETED";
}

function statusColor(status) {
  switch (status) {
    case "ACCEPTED":
      return "orange white--text";

    case "REJECTED":
      return "red white--text";

    case "CANCELLED":
      return "red white--text";

    case "ASSIGNED":
      return "blue white--text";

    case "COMPLETED":
      return "green white--text";

    default:
      return "green lighten-3 green--text text--darken-4";
  }
}

function statusDescription(status) {
  switch (status) {
    case "ACCEPTED":
      return "INVITATION ACCEPTED";

    case "REJECTED":
      return "INVITATION DECLINED";

    case "CANCELLED":
      return "INVITATION CANCELLED";

    case "ASSIGNED":
      return "REVIEWER ASSIGNED";

    case "COMPLETED":
      return "REVIEW COMPLETED";

    default:
      return "INVITATION SENT";
  }
}

export { canCancelAndRemind, statusColor, statusDescription };
